module.exports = __webpack_public_path__ + "static/img/insurance-product-2.0602d09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/insurance-product-2.png
// module id = sw8e
// module chunks = 4